<template>
  <div class="upload-form-area">
    <el-form :model="formData" :ref="formName">
      <div v-for="(item, index) of fieldList" :key="item.key">
        <el-row :gutter="10" class="form-row">

          <!-- 左邊label -->
          <el-col :span="item.leftSpan">
            <div class="form-label" v-if="item.label" v-html="item.label"></div>
          </el-col>
          <!-- 中間控件 -->
          <el-col v-if="item.midSpan != 0" :span="item.midSpan">
            <el-form-item :rules="getRules(item)" :prop="item.midKey">
              <el-select class="form-select" clearable v-if="item.midType == 'select'" v-model="formData[item.midKey]"
                placeholder="請選擇">
                <el-option v-for="dict in dict.type[item.midOptions]" :key="dict.value" :label="dict.label"
                  :value="dict.value">
                  <span style="float: left">{{ dict.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                dict.value
              }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 右邊控件 -->
          <el-col :span="item.rightSpan">
            <div class="form-input">
              <el-form-item :rules="getRules(item)" :prop="item.key">
                <!-- 文本框 當控件為金錢或者需要數字類型須做數字校驗-->
                <el-input v-if="item.type == 'input'" :readonly="item.readOnly" placeholder=""
                  v-model="formData[item.key]" @input="
                (v) =>
                  (formData[item.key] = item.isMoney || item.hasOwnProperty('needNumber')
                    ? v.replace(/[^\d]/g, '')
                    : formData[item.key])
              ">
                  <template v-if="item.isMoney" slot="prepend">$</template><template slot="append" v-if="item.needUnit">{{
                item.unit
              }}</template></el-input>
                <!-- 時間選擇控件 -->
                <el-date-picker type="date" v-if="item.type == 'date'" editable placeholder="請選擇日期" value-format="yyyy-MM-dd"
                  v-model="formData[item.key]">
                </el-date-picker>
                <!-- 選擇框 -->
                <el-select class="form-select" v-if="item.type == 'select'" v-model="formData[item.key]"
                  placeholder="請選擇">
                  <el-option v-for=" dict in dict.type[item.options]" :key="dict.value" :label="dict.label"
                    :value="dict.value">
                    <span style="float: left">{{ dict.label }}</span>
                  </el-option>
                </el-select>
                <!-- 上傳文檔 -->
                <div class="child-upload-area" v-if="item.type =='upload'">
                  <file-upload :limit="3" :files="formData[item.key]" uploadName="uploadFiles"
                    :fileLabel="item.fileLabel" @handFileUpload="handChildFileUpload"></file-upload>
                </div>
              </el-form-item>
              <div class="upload-tip" v-if="item.type =='upload'" v-html="item.uploadDesc"></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
  import FileUpload from "@/components/FileUpload";

  export default {
    components: {
      FileUpload
    },
    dicts: ["alimony_type", "use_of_land", "land_property", "company_property", "land_type", ],
    watch: {
      //2.1表单计算
      "formData.field21_A"(n, o) {
        this.form21ComputeFuc();
      },
      "formData.field21_B"(n, o) {
        this.form21ComputeFuc();
      },
      "formData.field21_C"(n, o) {
        this.form21ComputeFuc();
      },
      "formData.field21_D"(n, o) {
        this.form21ComputeFuc();
      },
      "formData.field21_E"(n, o) {
        this.form21ComputeFuc();
      },
      "formData.field21_F"(n, o) {
        this.form21ComputeFuc();
      },
      //2.3表单计算
      "formData.field23_A"(n, o) {
        this.form23ComputeFuc();
      },
      "formData.field23_B"(n, o) {
        this.form23ComputeFuc();
      },
      "formData.field23_C"(n, o) {
        this.form23ComputeFuc();
      },
      "formData.field23_D"(n, o) {
        this.form23ComputeFuc();
      },
      //3.1表单计算
      "formData.field31_10"(n, o) {
        this.form31ComputeFuc();
      },
      "formData.field31_11"(n, o) {
        this.form31ComputeFuc();
      },

      "formData.field31_14"(n, o) {
        this.form31ComputeFuc();
      },
      "formData.field31_15"(n, o) {
        this.form31ComputeFuc();
      },
      //文檔校驗
      "formData.uploadFiles"(n, o) {
        if (this.formData.uploadFiles.length > 0) {
          this.$refs[this.formName].clearValidate("uploadFiles");
        }
      },

      immediate: true,
    },
    props: {
      fieldList: Array,
      formName: String
    },
    data() {
      return {
        formData: {
          uploadFiles: []
        },
        uploadRules: [{
          required: true,
          message: '請上傳檔案資料',
          trigger: 'change'
        }]
      };
    },
    methods: {
      getChildrenFormValidata() {
        //驗證表單
        this.$refs[this.formName].validate((valid) => {
          if (valid) {
            console.log(JSON.stringify(this.formData))
            //将当前表单值回传给父组件
            let data = {
              formName: this.formName,
              formData: this.formData
            }
            this.$emit('handlerValid', true)
            this.$emit('handlerSumbit', data)
          } else {
            console.log("error uploadFileForm submit !!");
            this.validFail();
            this.$emit('handlerValid', false)
          }
        });
      },
      // 校验未通过时的处理
      validFail() {
        // 定位到错误信息位置
        setTimeout(() => {
          let isError = document.getElementsByClassName("is-error");
          isError[0].scrollIntoView({
            behavior: "smooth", // 平滑过渡
            block: 'center', //居中
          });;
        }, 100);
      },
      form31ComputeFuc() {
        //a、31_12 = 31_10 -31_11 b、 31_16 =  31_14 -31_15 c、 31_17 = (31_12 + 31_16) / 6
        var A = this.formData.field31_10 ? Number(this.formData.field31_10) : 0;
        var B = this.formData.field31_11 ? Number(this.formData.field31_11) : 0;
        var C = A - B;
        var D = this.formData.field31_14 ? Number(this.formData.field31_14) : 0;
        var E = this.formData.field31_15 ? Number(this.formData.field31_15) : 0;
        var F = D - E;
        this.formData.field31_12 = C;
        this.formData.field31_16 = F;
        this.formData.field31_17 = ((C + F) / 6).toFixed(2);
      },
      form21ComputeFuc() {
        var A = this.formData.field21_A ? Number(this.formData.field21_A) : 0;
        var B = this.formData.field21_B ? Number(this.formData.field21_B) : 0;
        var C = this.formData.field21_C ? Number(this.formData.field21_C) : 0;
        var D = this.formData.field21_D ? Number(this.formData.field21_D) : 0;
        var E = this.formData.field21_E ? Number(this.formData.field21_E) : 0;
        var F = this.formData.field21_F ? Number(this.formData.field21_F) : 0;
        this.formData.field21_6 = A + B + C + D + E - F;
      },
      form23ComputeFuc() {
        var A = this.formData.field23_A ? Number(this.formData.field23_A) : 0;
        var B = this.formData.field23_B ? Number(this.formData.field23_B) : 0;
        var C = this.formData.field23_C ? Number(this.formData.field23_C) : 0;
        this.formData.field23_D = B - C;
        this.formData.field23_E = (this.formData.field23_D / A).toFixed(2);
      },
      /*
       * 上传组件 上传成功回传列表
       */
      handChildFileUpload(data) {
        this.formData[data.fieldName] = data.files;
      },
      /**
       * 获取控件校验规则
       */
      getRules(item) {
        // debugger
        if (item.label.includes("(如有)") || item.label.includes("(如適用)")) {
          return []
        } else if ('upload' == item.type) {
          return this.uploadRules
        } else {
          return [{
            required: true,
            message: " ",
            trigger: item.type == 'input' ? 'blur' : 'change'
          }]
        }
      },
    },

  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/upload/child/formTemplate.vue